/**
 * PaymentErrorBanner — Shows an alert when any stage has errorMessage.
 */
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useAppSelector } from 'src/store/hooks';

export const PaymentErrorBanner = () => {
  const payment = useAppSelector(state => state.payment.data);
  if (!payment?.statusMap) return null;

  const failures: { stage: string; message: string }[] = [];
  Object.entries(payment.statusMap).forEach(([stage, detail]) => {
    if (detail.state === 'FAILED' || detail.errorMessage) {
      failures.push({
        stage: stage.replace(/_/g, ' '),
        message: detail.errorMessage || detail.paymentStatus || 'Unknown error',
      });
    }
  });

  if (failures.length === 0) return null;

  return (
    <Alert type="error" header={`${failures.length} error${failures.length > 1 ? 's' : ''} detected`}>
      <SpaceBetween size="xs">
        {failures.map((f, i) => (
          <Box key={i} fontSize="body-s">
            <Box fontWeight="bold" variant="span">{f.stage}</Box>
            {' — '}{f.message}
          </Box>
        ))}
      </SpaceBetween>
    </Alert>
  );
};
